module.exports = __webpack_public_path__ + "img/cart-icon-music-select.224c9190.svg";